import { autoinject, PLATFORM } from 'aurelia-framework';
import { HttpClient } from "aurelia-http-client";
import { AppUser } from '../model/app-user';
import { Toast } from './toast';

export interface IFilterParams {
	filter?: string;
	term?: string;
}

export interface IListParams extends IFilterParams {
	sort?: string;
	skip?: number;
	take?: number;
}

export interface IListIncludeParams extends IListParams {
	include?: string;
}

export interface IListSelectParams extends IListParams {
	select?: string;
}

@autoinject
export class ApiService {
	constructor(private _api: HttpClient, private _user: AppUser) {
		this._api.configure(x => {
			x.withBaseUrl(PLATFORM.global.$appConfig.apiRoot);
			x.withHeader("Accept", "application/json");
			x.withInterceptor({
				responseError: e => {
					let r: any = "Connection error";
					try { r = JSON.parse(e.response); }
					catch { }
					Toast.error(r.Message || r);

					if (e.statusCode === 401 || e.statusCode === 403)
						this._user.Id = 0;

					throw e;
				},
				response: msg => {
					let auth = msg.headers.get(PLATFORM.global.$appConfig.auth);
					if (auth) {
						this._user.Token = auth;
					}
					return msg;
				}
			})
		});
	}

	get(endpoint: string, params?: any, auth: boolean = true) {
		let api = this._api.createRequest(endpoint)
			.asGet();
		if (params)
			api = api.withParams(params);
		if (auth)
			api = api.withHeader(PLATFORM.global.$appConfig.auth, this._user.Token);

		return api.send();
	}
	getBlob(endpoint: string, params?: any, auth: boolean = true) {
		let api = this._api.createRequest(endpoint)
			.asGet();
		if (params)
			api = api.withParams(params);
		if (auth)
			api = api.withHeader(PLATFORM.global.$appConfig.auth, this._user.Token);

		return api.withResponseType("blob").send();
	}
	post(endpoint: string, params: any, content?: any, auth: boolean = true) {
		let api = this._api.createRequest(endpoint)
			.asPost();
		if (params)
			api = api.withParams(params);
		if (content)
			api = api.withContent(content);
		if (auth)
			api = api.withHeader(PLATFORM.global.$appConfig.auth, this._user.Token);

		return api.send();
	}
	put(endpoint: string, params: any, content?: any, auth: boolean = true) {
		let api = this._api.createRequest(endpoint)
			.asPut();
		if (params)
			api = api.withParams(params);
		if (content)
			api = api.withContent(content);
		if (auth)
			api = api.withHeader(PLATFORM.global.$appConfig.auth, this._user.Token);

		return api.send();
	}
	delete(endpoint: string, params: any, content?: any, auth: boolean = true) {
		let api = this._api.createRequest(endpoint)
			.asDelete();
		if (params)
			api = api.withParams(params);
		if (content)
			api = api.withContent(content);
		if (auth)
			api = api.withHeader(PLATFORM.global.$appConfig.auth, this._user.Token);

		return api.send();
	}

	getEntity(endpoint: string, id: number, include?: string) {
		let params: any = { id: id };
		if (include) params.include = include;

		return this.get(endpoint, params);
	}

	getAll(endpoint: string, params?: IListIncludeParams) {
		return this.get(endpoint, params);
	}

	projectAll(endpoint: string, params: IListSelectParams) {
		return this.get(endpoint, params);
	}

	query(endpoint: string, expression: string) {
		return this.get(endpoint + "/query", { ex: expression });
	}

	queryAll(expression: string) {
		return this.get("db/query", { ex: expression });
	}

	count(endpoint: string, params: IFilterParams) {
		return this.get(endpoint + "/count", params);
	}

	queryCount(endpoint: string, expression: string) {
		return this.get(endpoint + "/query/count", { ex: expression });
	}

	queryAllCount(expression: string) {
		return this.get("db/query/count", { ex: expression });
	}
}
